import { render, staticRenderFns } from "./reportCoverApp.vue?vue&type=template&id=2dd69c6d&"
import script from "./reportCoverApp.vue?vue&type=script&lang=js&"
export * from "./reportCoverApp.vue?vue&type=script&lang=js&"
import style0 from "./reportCoverApp.vue?vue&type=style&index=0&id=2dd69c6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports